/** Formatea un número con separador de miles "." y decimales ",", igual en toda la app
 * (ej. 1398.96 -> "1.398,96"). No incluye símbolo de moneda; cada pantalla antepone el suyo
 * (simbolo de la cuenta, "+", "-", etc.) para no perder ese contexto visual ya existente. */
export function formatoNumero(valor) {
  return Number(valor || 0).toLocaleString("es-ES", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
